<template>
    <c-dialog ref="dialog" width="600" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-input type="hidden" name="id"></c-input>
            <c-form-item label="昵称" required>
                <c-input name="nickname" maxlength="20" placeholder="请输入昵称"></c-input>
            </c-form-item>
            <c-form-item label="手机号码" required>
                <c-input name="phone" maxlength="11" placeholder="请输入11位手机号码"></c-input>
            </c-form-item>
            <c-form-item label="性别">
                <c-radio-group name="gender" v-model="gender" :options="genderOptions" :clear="false"></c-radio-group>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    data() {
        return {
            editState: false,
            gender: undefined,
            /* 性别选项 */
            genderOptions: [
                {name: '男', value: 1, color: 'blue'},
                {name: '女', value: 2, color: 'pink'}
            ]
        }
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.editState = false;
            this.$refs.form.clear();
            if (data) {
                this.editState = true;
                this.$refs.form.set(data);
                this.gender = data.gender;
            } else {
                // 新增时设置默认值
                this.$refs.form.set({
                    member_level: 1
                });
                this.gender = 1;
            }
            // 填充form表单
            this.$refs.dialog.open({
                title: data ? '编辑会员' : '新增会员'
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: this.editState ? '/mall/member/edit' : '/mall/member/add',
                rule: {
					nickname: '请输入昵称',
                    phone: [{
                        type: 'empty',
                        message: '请输入手机号码'
                    }, {
                        type: 'regexp',
                        regexp: ['phone'],
                        message: '手机号格式异常，请输入11位手机号'
                    }],
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    if (this.editState) {
                        this.$message({
                            message: '编辑成功',
                            type: 'success'
                        });
                    } else {
                        this.$confirm({
                            message: res,
                            buttonName: '知道了',
                            cancelButton: false,
                            resolve: () => {
                            }
                        });
                    }
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
